import '../../styles/rfiElements.css';
import React from 'react';
import { isEqual } from 'lodash';
import { IElementProps } from 'types/RfiTypes';

const SectionElement = (props: IElementProps) => {
  //Render

  return (
    <div className="col-lg-8 mb-3 pl-0 border-bottom">
      <strong>
        <a id={`section-${props.element.elementId}`}></a>{" "}
        <h3 className="h5 pb-1 mb-0 sectionTitle">
          {props.element.fieldLabel}
        </h3>
      </strong>
    </div>
  );
};

// Only re-render if props changed
const areEqual = (prevProps: IElementProps, nextProps: IElementProps) => {
  return (
    isEqual(prevProps.element, nextProps.element) &&
    isEqual(prevProps.designMode, nextProps.designMode)
  );
};

const SectionHeaderElement = React.memo(SectionElement, areEqual);

export default SectionHeaderElement;
